<template>
<!--  <v-row align="center" no-gutters style="display: block">-->
<!--    <v-col class="text-left">-->
<!--      <v-btn fab x-small rounded elevation="0" icon  outlined color="grey" class="text-left font-weight-bold">-->
<!--        <v-icon  color="black"  small>mdi-dots-grid</v-icon>-->
<!--      </v-btn>-->
  <v-sheet class="text-body-2 font-weight-bold">
    Tips: Hidden columns can be shown by using the button at right-top corner of the table.
  </v-sheet>

<!--    </v-col>-->
<!--    <v-spacer></v-spacer>-->
<!--  </v-row>-->
</template>

<script>
export default {
  name: "LegendHintHiddenTableColumns"
}
</script>

<style scoped>

</style>